module.exports = __webpack_public_path__ + "img/ic_fluent_arrow_minimize_28_filled.2a19cb3b.svg";